{
  "commonHeader": {
    "toggleSidebar": "切换侧边栏",
    "cartLoading": "购物车加载中",
    "cart": "购物车",
    "aicForAdmin": {
      "ariaLabel": "管理员 AI"
    },
    "usersResults": "用户，{0} 条结果",
    "settingsResults": "设置，{0} 条结果",
    "navigationResults": "导航，{0} 条结果",
    "learnMoreAbout": "详细了解 {0}",
    "close": "关闭",
    "products": "产品",
    "moreActions": "更多操作",
    "search": "搜索",
    "searchPlaceholderAll": "搜索用户、账户设置或导航",
    "searchPlaceholderUsers": "搜索用户或导航",
    "searchPlaceholderSettings": "搜索账户设置或导航",
    "searchPlaceholderNav": "搜索导航"
  },
  "footerCopyright": {
    "language": "语言 {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "管理员菜单"
    }
  },
  "shared": {
    "close": "关闭",
    "sideMenu": {
      "personalAria": "个人菜单",
      "adminAria": "管理员菜单",
      "mainNav": "主导航",
      "submenu": "子菜单",
      "pinnedSection": "{0}已固定",
      "sideMenuAria": "侧边菜单",
      "pinItem": "固定 {0}",
      "unpinItem": "取消固定 {0}",
      "reorderGrabbed": "正在重新排序 {0}，已抓取。使用上下箭头键移动，按空格或回车放下，按 Esc 取消。",
      "reorderIdle": "重新排序 {0}。按空格或回车抓取。",
      "hintHandlePin": "按 Tab 键访问拖动手柄和固定按钮",
      "hintHandle": "按 Tab 键访问拖动手柄",
      "hintPin": "按 Tab 键访问固定按钮",
      "upgradeToPro": "升级到专业版"
    },
    "item": "项目"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "体验新界面"
    }
  },
  "aicGuide": {
    "common": {
      "close": "关闭"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "分区现已可用"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "管理外部账户"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "通讯录将更名为客户目录"
    }
  },
  "feedback": {
    "itemLableForProductArea": "产品领域",
    "itemLableForFeedback": "反馈"
  }
}
